var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgAiAgents = function SvgAiAgents(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 112,
    height: 112,
    viewBox: "0 0 112 112",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 56C7 28.938 28.938 7 56 7C83.062 7 105 28.938 105 56C105 69.7108 99.3687 82.1064 90.2929 91H91C94.866 91 98 94.134 98 98C98 101.866 94.866 105 91 105H21C17.134 105 14 101.866 14 98C14 94.134 17.134 91 21 91H21.7071C12.6313 82.1064 7 69.7108 7 56ZM71.75 56C68.8507 56 66.5 53.6495 66.5 50.75V45.5H61.25C58.3507 45.5 56 43.1495 56 40.25C56 37.3505 58.3507 35 61.25 35H66.5V29.75C66.5 26.8505 68.8507 24.5 71.75 24.5C74.6493 24.5 77 26.8505 77 29.75V35H82.25C85.1493 35 87.5 37.3505 87.5 40.25C87.5 43.1495 85.1493 45.5 82.25 45.5H77V50.75C77 53.6495 74.6493 56 71.75 56ZM42 63C42 66.866 45.134 70 49 70C52.866 70 56 66.866 56 63C56 59.134 52.866 56 49 56C45.134 56 42 59.134 42 63Z",
    fill: "url(#paint0_linear_9575_201506)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9575_201506",
    x1: 80.5,
    y1: 7,
    x2: 55.1922,
    y2: 104.791,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8066"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E666FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#66B3FF"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgAiAgents);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ai-agents.e259e7ddac86bc1bef57961283ec0fa0.svg";